<form [formGroup]="paramFormLirisV2" *ngIf="!readOnly">
    <mat-form-field>
        <input matInput placeholder="ParamA" formControlName="paramA" required type="number">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="ParamB" formControlName="paramB" required type="number">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="ParamC" formControlName="paramC" required type="number">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="{{'TRIGGER'|translate}}" formControlName="trigger" required type="number">
    </mat-form-field>

</form>

<form *ngIf="readOnly">
    <mat-form-field class="readonly">
        <input matInput placeholder="ParamA" [value]="paramFormLirisV2.value.paramA" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="readonly">
        <input matInput placeholder="ParamB" [value]="paramFormLirisV2.value.paramB" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="readonly">
        <input matInput placeholder="ParamC" [value]="paramFormLirisV2.value.paramC" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="readonly">
        <input matInput placeholder="{{'TRIGGER'|translate}}" [value]="paramFormLirisV2.value.trigger"
               [readonly]="true">
    </mat-form-field>
</form>
